/**
 * Models API
 *
 * API calls for model configuration
 * Reference: api/services/models_service.py, api/routers/admin/models.py
 */

import { apiClient } from './client';
import type {
  ModelInfo,
  ModelsHealthStatus,
  ModelCatalogResponse,
} from '@/types';

const BASE_PATH = '/models';

export const modelsApi = {
  /**
   * Unified model catalog (Track B-3c): every model the deployment serves,
   * as the full dual-descriptor ModelInfo (billing + capability) with live
   * dora editorial. Maps GET /v1/admin/models/catalog.
   */
  getCatalog: async (): Promise<ModelCatalogResponse> => {
    const response = await apiClient.get(`${BASE_PATH}/catalog`);
    return response.data;
  },

  /**
   * Get detailed information about a specific model
   */
  getModel: async (modelId: string): Promise<ModelInfo> => {
    const response = await apiClient.get(`${BASE_PATH}/${encodeURIComponent(modelId)}`);
    return response.data;
  },

  /**
   * Get models service health status
   */
  getHealth: async (): Promise<ModelsHealthStatus> => {
    const response = await apiClient.get(`${BASE_PATH}/health`);
    return response.data;
  },

  /**
   * Force refresh the models cache
   */
  refreshCache: async (): Promise<{ success: boolean; message: string; models_count: number }> => {
    const response = await apiClient.post(`${BASE_PATH}/refresh`);
    return response.data;
  },
};
